import bridge from '@/utils/bridge';

function openInviteContactScreen(gaSourceName) {
  bridge.tell('Shell', 'openBuddyAdderDialog', [gaSourceName]);
}

function openCreateChannelScreen(session, gaSourceName) {
  bridge.tell('Shell', 'openChannelType', [session, gaSourceName]);
}

function openChannelDiscoveryScreen(gaSourceName) {
  bridge.tell('Shell', 'openChannelDiscovery', [gaSourceName]);
}

function getOpenGroupCount() {
  return bridge.ask('Shell', 'getOpenGroupCount');
}

function toggleSidebarState() {
  return bridge.tell('Shell', 'toggleSidebarState');
}

function showAboutUs() {
  bridge.tell('Shell', 'showAboutUs');
}

function openAdminPanel() {
  bridge.tell('Shell', 'openAdminPanel');
}

function showReportBugPopup() {
  bridge.tell('Shell', 'showReportBugPopup');
}

function showKeyboardShortcuts() {
  bridge.tell('Shell', 'showKeyboardShortcuts');
}

function getCurrentConversation() {
  return bridge.ask('Shell', 'getCurrentConversation');
}

function changeConversation(jid, guid) {
  bridge.tell('ConversationHandler', 'openConversation', [
    {
      jid,
      ownerGuid: guid,
    },
  ]);
}

function showAddNewTeam(accountEmail, teamId) {
  bridge.tell('Shell', 'showAddTeam', [accountEmail, teamId]);
}

function showReferSomeoneModal() {
  bridge.tell('Shell', 'openReferAdderDialog', ['app_menu_item_invite']);
}

function showWhatsNewUrl() {
  bridge.tell('Shell', 'showWhatsNewUrl', []);
}

function exit() {
  bridge.tell('HydraServer', 'exit');
}

function getPublicChannels(sessionId) {
  return bridge.ask(`Session_${sessionId}`, 'getOpenGroups');
}

function joinPublicChannel(sessionId, channelJid) {
  return bridge.ask(`Session_${sessionId}`, 'joinGroup', [channelJid]);
}

function signout(email) {
  return bridge.ask('TeamSessionRegistry', 'signOutAccount', [email]);
}

export {
  openInviteContactScreen,
  openCreateChannelScreen,
  openChannelDiscoveryScreen,
  getOpenGroupCount,
  toggleSidebarState,
  showWhatsNewUrl,
  showAboutUs,
  openAdminPanel,
  showReportBugPopup,
  showKeyboardShortcuts,
  getCurrentConversation,
  changeConversation,
  showAddNewTeam,
  showReferSomeoneModal,
  exit,
  getPublicChannels,
  joinPublicChannel,
  signout,
};



// WEBPACK FOOTER //
// ./src/utils/ShellUtils.js